import type { MatchSpan } from './types';

/**
 * Step 2 — attach or refine confidence on spans.
 * When disabled, the pipeline strips confidence fields from spans and reports
 * metrics.confidence = null.
 *
 * Current implementation: keep extractor-provided confidences as-is (patterns
 * already stamped confidence at match time). Future iterations can adjust
 * scores from conflicts, ambiguity, or fuzzy matches.
 */
export function applyConfidenceStep(spans: ReadonlyArray<MatchSpan>): MatchSpan[] {
  return spans.map(span => ({
    ...span,
    confidence: span.confidence ?? 0.8,
  }));
}

/** Weighted mean of span confidences by span length. */
export function overallConfidence(spans: ReadonlyArray<MatchSpan>): number | null {
  let weight = 0;
  let sum = 0;
  for (const span of spans) {
    if (span.confidence === undefined) continue;
    const len = Math.max(1, span.end - span.start);
    weight += len;
    sum += span.confidence * len;
  }
  if (weight === 0) return null;
  return sum / weight;
}

export function stripConfidence(spans: ReadonlyArray<MatchSpan>): MatchSpan[] {
  return spans.map(({ confidence: _confidence, ...rest }) => rest);
}
